import React from "react";
import { Link } from "react-router-dom";
// Import reference logos
import IzmirLogo from "../assets/references/izmir.png";
import UmtasLogo from "../assets/references/umtas.png";
import AcarLogo from "../assets/references/acar.png";
import GnrLogo from "../assets/references/gnr.png";
import B1Logo from "../assets/references/b1logo.png";
import UsakLogo from "../assets/references/usak.png";
import istanbulLogo from "../assets/references/istanbul.jpg";
import kocaeliLogo from "../assets/references/kocaeli.png";
import aygLogo from "../assets/references/ayg.png";
import emitekLogo from "../assets/references/emitek.jpg";
import vestelLogo from "../assets/references/vestel.jpg";
import manisaLogo from "../assets/references/manisa.png";
import bursaLogo from "../assets/references/bursa.png";
import canakkaleLogo from "../assets/references/canakkale.png";
import aydinLogo from "../assets/references/aydin.png";
import erzurumLogo from "../assets/references/erzurum.png";
import kutahyaLogo from "../assets/references/kutahya.png";
import bigaLogo from "../assets/references/biga.jpg";
import uzunkopruLogo from "../assets/references/uzunkopru.png";
import marmarisLogo from "../assets/references/marmaris.png";
import zimagLogo from "../assets/references/zimag.png";
import esitfaiyeLogo from "../assets/references/esitfaiye.jpg";
import ogemsanLogo from "../assets/references/ogemsan.jpeg";
import gffLogo from "../assets/references/gff.png";

const HomePage: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-primary-700 to-primary-500 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32">
          <div className="md:w-2/3">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Endüstriyel Ekipman ve Otomasyonlar
            </h1>
            <p className="text-lg md:text-xl mb-8">
              Yılların tecrübesi ile geliştirdiğimiz ürünlerimiz ile sizlere en
              iyi hizmeti sunuyoruz.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link
                to="/iletisim"
                className="bg-white text-primary-600 hover:bg-gray-100 px-6 py-3 rounded-md font-medium transition-colors"
              >
                İletişime Geçin
              </Link>
            </div>
          </div>
        </div>
        <div
          className="absolute bottom-0 right-0 w-full h-16 bg-white"
          style={{ clipPath: "polygon(100% 0, 0% 100%, 100% 100%)" }}
        ></div>
      </section>

      {/* Çalışma Alanlarımız Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Çalışma Alanlarımız
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Uzmanlık alanlarımız ve hizmet verdiğimiz sektörler
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:scale-105 p-6">
              <div className="h-16 w-16 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 text-3xl mb-4 mx-auto">
                💻
              </div>
              <h3 className="text-xl font-semibold mb-3 text-center">
                Yazılım
              </h3>
              <p className="text-gray-600 text-center">
                Özel projeleriniz için yazılım çözümleri geliştiriyoruz. Kontrol
                sistemleri, veri analitiği ve arayüz tasarımı.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:scale-105 p-6">
              <div className="h-16 w-16 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 text-3xl mb-4 mx-auto">
                🔌
              </div>
              <h3 className="text-xl font-semibold mb-3 text-center">
                Donanım
              </h3>
              <p className="text-gray-600 text-center">
                Yüksek kaliteli donanım çözümleri tasarlıyor ve üretiyoruz.
                Dayanıklı ve güvenilir elektronik sistemler.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:scale-105 p-6">
              <div className="h-16 w-16 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 text-3xl mb-4 mx-auto">
                🔬
              </div>
              <h3 className="text-xl font-semibold mb-3 text-center">Ar-Ge</h3>
              <p className="text-gray-600 text-center">
                Sürekli yenilikçilik ve araştırma-geliştirme ile sektörde öncü
                çözümler sunuyoruz.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:scale-105 p-6">
              <div className="h-16 w-16 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 text-3xl mb-4 mx-auto">
                ✏️
              </div>
              <h3 className="text-xl font-semibold mb-3 text-center">
                Özel Tasarımlar
              </h3>
              <p className="text-gray-600 text-center">
                İhtiyaçlarınıza özel tasarım ve üretim hizmetleri. Projelerinize
                özel çözümler geliştiriyoruz.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* References Section */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-gray-900">
              Referanslarımız
            </h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
            <div className="flex justify-center">
              <img
                src={IzmirLogo}
                alt="İzmir"
                className="h-16 object-contain"
              />
            </div>
            <div className="flex justify-center">
              <img
                src={UmtasLogo}
                alt="UMTAŞ"
                className="h-16 object-contain"
              />
            </div>
            <div className="flex justify-center">
              <img src={AcarLogo} alt="Acar" className="h-16 object-contain" />
            </div>
            <div className="flex justify-center">
              <img src={GnrLogo} alt="GNR" className="h-16 object-contain" />
            </div>
            <div className="flex justify-center">
              <img src={B1Logo} alt="B1Logo" className="h-16 object-contain" />
            </div>{" "}
            <div className="flex justify-center">
              <img src={UsakLogo} alt="Usak" className="h-16 object-contain" />
            </div>
            <div className="flex justify-center">
              <img
                src={istanbulLogo}
                alt="İstanbul"
                className="h-16 object-contain"
              />
            </div>
            <div className="flex justify-center">
              <img
                src={kocaeliLogo}
                alt="Kocaeli"
                className="h-16 object-contain"
              />
            </div>
            <div className="flex justify-center">
              <img src={aygLogo} alt="AYG" className="h-16 object-contain" />
            </div>
            <div className="flex justify-center">
              <img
                src={emitekLogo}
                alt="Emitek"
                className="h-16 object-contain"
              />
            </div>
            <div className="flex justify-center">
              <img
                src={vestelLogo}
                alt="Vestel"
                className="h-16 object-contain"
              />
            </div>{" "}
            <div className="flex justify-center">
              <img
                src={manisaLogo}
                alt="Manisa"
                className="h-16 object-contain"
              />
            </div>{" "}
            <div className="flex justify-center">
              <img
                src={bursaLogo}
                alt="Bursa"
                className="h-16 object-contain"
              />
            </div>
            <div className="flex justify-center">
              <img
                src={canakkaleLogo}
                alt="Canakkale"
                className="h-16 object-contain"
              />
            </div>
            <div className="flex justify-center">
              <img
                src={aydinLogo}
                alt="Aydın"
                className="h-16 object-contain"
              />
            </div>
            <div className="flex justify-center">
              <img
                src={erzurumLogo}
                alt="Erzurum"
                className="h-16 object-contain"
              />
            </div>{" "}
            <div className="flex justify-center">
              <img
                src={kutahyaLogo}
                alt="Kutahya"
                className="h-16 object-contain"
              />
            </div>{" "}
            <div className="flex justify-center">
              <img src={bigaLogo} alt="Biga" className="h-16 object-contain" />
            </div>{" "}
            <div className="flex justify-center">
              <img
                src={uzunkopruLogo}
                alt="Uzunkopru"
                className="h-16 object-contain"
              />
            </div>
            <div className="flex justify-center">
              <img
                src={marmarisLogo}
                alt="Marmaris"
                className="h-16 object-contain"
              />
            </div>
            <div className="flex justify-center">
              <img
                src={zimagLogo}
                alt="Zimag"
                className="h-16 object-contain"
              />
            </div>
            <div className="flex justify-center">
              <img
                src={esitfaiyeLogo}
                alt="Esitfaiye"
                className="h-16 object-contain"
              />
            </div>
            <div className="flex justify-center">
              <img
                src={ogemsanLogo}
                alt="Ogemsan"
                className="h-16 object-contain"
              />
            </div>
            <div className="flex justify-center">
              <img src={gffLogo} alt="Gff" className="h-16 object-contain" />
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-10 md:mb-0">
              <h2 className="text-3xl font-bold mb-6">Hakkımızda</h2>
              <p className="text-gray-300 text-lg mb-6">
                Yıltek olarak, yılların sektör tecrübesi ile Endüstriyel Ekipman
                ve Otomasyon alanında çözümler sunuyoruz. Müşteri memnuniyetini
                ön planda tutarak, kaliteli ürünler ve hizmetler sağlıyoruz.
              </p>
              <Link
                to="/kurumsal"
                className="inline-block bg-primary-600 hover:bg-primary-700 text-white font-medium px-6 py-3 rounded-md transition-colors"
              >
                Daha Fazla Bilgi
              </Link>
            </div>
            <div className="md:w-1/2 md:pl-12">
              <div className="bg-primary-100 p-8 rounded-lg">
                <ul className="space-y-4">
                  <li className="flex items-start">
                    <div className="flex-shrink-0 mr-3 mt-1">
                      <div className="w-6 h-6 rounded-full bg-primary-600 flex items-center justify-center text-white font-bold">
                        ✓
                      </div>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900">
                        Kaliteli Ürünler
                      </h3>
                      <p className="text-gray-700">
                        Yüksek kalitede ve uzun ömürlü ürünler üretiyoruz.
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start">
                    <div className="flex-shrink-0 mr-3 mt-1">
                      <div className="w-6 h-6 rounded-full bg-primary-600 flex items-center justify-center text-white font-bold">
                        ✓
                      </div>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900">
                        Teknik Destek
                      </h3>
                      <p className="text-gray-700">
                        Satış sonrası teknik destek hizmetleri sunuyoruz.
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start">
                    <div className="flex-shrink-0 mr-3 mt-1">
                      <div className="w-6 h-6 rounded-full bg-primary-600 flex items-center justify-center text-white font-bold">
                        ✓
                      </div>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900">
                        İnovasyon
                      </h3>
                      <p className="text-gray-700">
                        Sürekli gelişme ve yenilikçilik prensibi ile
                        çalışıyoruz.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-primary-500 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-6">
            Projeleriniz İçin Bize Ulaşın
          </h2>
          <p className="text-lg mb-8 max-w-3xl mx-auto">
            Özel çözümler için ekibimiz sizinle görüşmeye hazır. İhtiyaçlarınızı
            belirleyelim ve size en uygun çözümü sunalım.
          </p>
          <Link
            to="/iletisim"
            className="inline-block bg-white text-primary-600 hover:bg-gray-100 font-medium px-8 py-4 rounded-md text-lg transition-colors"
          >
            Hemen İletişime Geçin
          </Link>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
